import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class OpenSeaAPIService {
  private options = {
    method: "GET",
    headers: {
      accept: "application/json",
      "x-api-key": environment.openSeaAPIKey,
    },
  };

  constructor(private http: HttpClient) {}

  getDetail(endpoint: string) {
    return this.http.get(
      `${environment.openSeaEndpoint}${endpoint}`,
      this.options
    );
  }
}
